module.exports = __webpack_public_path__ + "media/images/stop-recording-fdd715d0.png";